import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { filter, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RobotsService implements OnDestroy {
  private routerSubscription: Subscription;
  private noIndexTag = { name: 'robots', content: 'noindex' };
  private excludedRoutes = [
    'home',
    'blog/categoria/:id',
    'verificando-firma',
    'ops/dashboard',
    'rates',
    '4B6XN8K2H7VY3W9M5Q1Z9A3JN7M5D1H8S4L0F2K',
    'mis-procesos',
    'portal/login',
    'portal/dashboard',
    'validar-identidad',
    'sube-tus-documentos',
    'asegura-tu-tasa',
    'transfiere-el-dinero',
    'sube-el-comprobante-de-pago',
    'firma-los-documentos',
    'cdt-completado',
    'continuar-proceso',
    'no-podemos-continuar-con-tu-proceso',
    'firma-los-documentos-en-fisico',
    'jumbo-cdt',
    'trabajo/:id',
    'prensa/:path',
    'datos-personales',
    'datos-financieros',
    'consulta-en-listas',
    'preguntas-bancamia',
    'preguntas-ban100',
    'preguntas-bancow',
    'preguntas-bancomundomujer',
    'preguntas-mibanco',
    'preguntas-coltefinanciera',
    'preguntas-credifamilia',
    'preguntas-iris',
    'preguntas/coltefinanciera/flamingo',
    'preguntas-cdturbo',
    'v2/preguntas-cdturbo',
    'v2/datos-personales',
    'v2/datos-financieros',
    'v2/preguntas-bancamia',
    'v2/preguntas-ban100',
    'v2/preguntas-bancow',
    'v2/preguntas-bancomundomujer',
    'v2/preguntas-mibanco',
    'v2/preguntas-coltefinanciera',
    'v2/preguntas-credifamilia',
    'v2/preguntas-iris',
    'v2/preguntas/coltefinanciera/flamingo',
    'v2/preguntas-koa',
    'confirma-tus-datos',
    'bienvenida-usuario-retorno',
    'orden-inversion',
    'cancelacion',
    'vinculacion-ban100',
    'vinculacion-credifinanciera',
    'vinculacion-ibr-credifinanciera',
    'vinculacion-mundo-mujer',
    'vinculacion-banco-w',
    'vinculacion-mibanco',
    'vinculacion-coltefinanciera',
    'tripetto-tes',
    'widget-simulador',
    'cdt-ibrcredifinanciera',
    'ab-testing',
    '404',
    'ab-testing/cdt-simulador',
    'portal/login',
    'login',
    'bloqueo-temporal',
    'te-contactaremos',
    'portal'
  ];

  constructor(private router: Router, private meta: Meta) {
    this.routerSubscription = this.router.events.pipe(
      filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.handleRouteChange(event.urlAfterRedirects);
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.removeNoIndexTag();
  }

  private handleRouteChange(url: string): void {
    const urlWithoutQueryParams = url.split('?')[0];

    if (this.excludedRoutes.includes(urlWithoutQueryParams)) {
      this.addNoIndexTag();
    } else {
      this.removeNoIndexTag();
    }
  }

  private addNoIndexTag(): void {
    this.meta.addTag(this.noIndexTag);
  }

  private removeNoIndexTag(): void {
    this.meta.removeTag(`name='${this.noIndexTag.name}'`);
  }
}
